// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZEyy","question":"styles_question__2g83X","description":"styles_description__3-fOM"};